import {RootState} from '../store';

export const filterInitializedSelector = ({filter: {initialized}}: RootState) => initialized;
